// Transaction types: shared bits for the list, the editor and the record
// form. split() mirrors the server (transaction_types.py) so previews show
// exactly what will be posted.

export const SHARES = [
  { id: 'rest', label: 'The rest' },
  { id: 'percent', label: 'Percent of amount' },
  { id: 'fixed', label: 'Fixed amount' },
]

const r2 = (v) => Math.round((Number(v) + 1e-9) * 100) / 100

/** Lines of the entry for amount: [{key, side, account_code, label, dr, cr}], or throws an Error. */
export function split(lines, amount, picks = {}) {
  const total = r2(amount)
  if (!(total > 0)) throw new Error('Enter an amount above zero.')
  const out = []
  for (const side of ['debit', 'credit']) {
    const sideLines = lines.filter((l) => l.side === side)
    const parts = {}
    sideLines.forEach((l, i) => {
      if (l.share === 'percent') parts[i] = r2(total * Number(l.share_value || 0) / 100)
      if (l.share === 'fixed') parts[i] = r2(l.share_value || 0)
    })
    const rest = r2(total - Object.values(parts).reduce((a, b) => a + b, 0))
    if (rest < 0) throw new Error(`The fixed and percent ${side}s come to more than the amount.`)
    sideLines.forEach((l, i) => {
      const value = i in parts ? parts[i] : rest
      if (!value) return
      const code = (l.can_change && picks[l.line_id]) || l.account_code
      out.push({ key: `${side}-${i}`, line_id: l.line_id, side, account_code: code, label: l.label || '', dr: side === 'debit' ? value : 0, cr: side === 'credit' ? value : 0 })
    })
  }
  return out
}

/** "10% of the amount", "$2.00", "the rest". */
export const shareText = (l, money) => (l.share === 'percent' ? `${Number(l.share_value)}%` : l.share === 'fixed' ? money(l.share_value) : 'the rest')
